export enum KeiAiModels {
  NanoBanana = 'nano-banana-2',
  NanoBananaLite = 'nano-banana-2-lite',
  NanoBanana21 = 'nano-banana-2-1',
  Qwen3Pro = 'qwen3/pro-image-to-image',
  GrokImagine = 'grok-imagine-image-2-0/image-edit',
  Wan = 'wan/2-7-image',
}

export enum KeiAiTextModels {
  Gpt52 = 'gpt-5-2',
  Gpt55 = 'gpt-5-5',
  Gpt6Astra = 'gpt-6-astra',
  Gpt6Luna = 'gpt-6-luna',
  Grok47 = 'grok-4-7',
  ClaudeOpus55 = 'claude-opus-5-5',
}
